import { render, staticRenderFns } from "./cardSuccess.vue?vue&type=template&id=2163067d&scoped=true&lang=pug&"
import script from "./cardSuccess.vue?vue&type=script&lang=js&"
export * from "./cardSuccess.vue?vue&type=script&lang=js&"
import style0 from "./cardSuccess.vue?vue&type=style&index=0&id=2163067d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163067d",
  null
  
)

export default component.exports